<template>
  <div class="pt-3 px-2">

    <p v-if="contacts.length == 0" class="text-center">No contacts</p>

    <span v-else>

      <!--- Desktop --->
      <table class="table d-none d-md-table">
        <thead class="thead-dark">
          <tr>
            <th class="first-left pl-3" width="10%">Business ({{total}})</th>
            <th class="pl-3" width="40%">Emails</th>
            <!-- <th class="pl-3" width="20%">Websites</th> -->
            <th class="pl-3" width="10%">Category</th>
            <th class="pl-3" width="10%">Status</th>
            <th class="pl-3" width="10%">Updated</th>
            <th class="pl-3" width="10%">Sent</th>
            <th class="first-right px-3" width="10%">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="body2" v-for="(contact, index) in contacts" :key="index">
            <td class="pl-3">{{contact.name}}</td>

            <td class="pl-3">
              <div v-for="(email, index) in contact.emails" :key="index">
              <div>
                <a :href="getWebsite(email)" target="_blank"><i class="fas fa-external-link-alt mr-2"></i></a>
                <a :href="`mailto:${email}`" target="_blank">{{email}}</a>
              </div>
              </div>
            </td>

            <!-- <td class="pl-3">
              <div v-for="(website, index) in contact.websites" :key="index">
              <div><a :href="formatWebsite(website)" target="_blank">{{website}}</a></div>
              </div>
            </td> -->
            
            <td class="pl-3">{{contact.category}}</td>
            <!-- <td class="pl-3">{{contact.location}}</td> -->
            <td class="pl-3">{{contact.status}}</td>
            <td class="pl-3 text-nowrap">
                <div :title="formatDateMoment(contact.updated_at, timezone)">
                  {{ timeAgo(contact.updated_at, timezone) }}
                </div>
            </td>
            <td class="pl-3">{{ contact.emails_sent }}</td>
            <td class="pl-3">
              <a 
                href="#/"
                title="Unsubscribe"
                :class="`unsub_link_${contact.id}`"
                @click="unsubscribe(contact)"><i class="fas fa-trash mr-4"></i></a>
              <a
                href="#/"
                title="View contact"
                @click="showModalViewContact(contact)"><i class="fa-solid fa-eye mr-4"></i></a>
              <a
                href="#/"
                title="Edit contact"
                @click="showModalEditContact(contact)"><i class="fa-solid fa-pen-to-square mr-4"></i></a>
              <a v-if="contact.status == 'Waiting' && contact.emails_sent == 0"
                href="#/"
                title="Send message"
                :class="`send_link_${contact.id}`"
                @click="sendMessage(contact)"><i class="fas fa-share debit"></i></a>
                <a v-if="!updating && contact.status == 'Waiting' && contact.emails_sent > 0"
                  href="#/"
                  title="Mark as contacted"
                  :class="`send_link_${contact.id}`"
                  @click="contacted(contact)"><i class="fas fa-check-circle credit"></i></a>
              <span
                title="Sending"
                id="sending"
                :class="`sending_${contact.id}`"><i class="fas fa-spinner fa-spin"></i></span>
              <span
                title="Unsubscribing"
                id="unsubscribing"
                :class="`unsub_${contact.id}`"><i class="fas fa-spinner fa-spin"></i></span>
            </td>
          </tr>
        </tbody>
      </table>

    </span>
    <view-contact
      v-if="contactInfo"
      :contact="contactInfo"
      :page="page"
      ref="ViewContact"></view-contact>
    <edit-contact
      v-if="contactInfo"
      :contact="contactInfo"
      :page="page"></edit-contact>
</div>
</template>

<script>
import { EventBus } from "../bus";

export default {
  props: ['search_term', 'status', 'page', 'category'],

  watch: {
    search_term: function (val) {
      this.getContacts();
    },

    category: function (val) {
      this.getContacts();
    },
  },

  data() {
    return {
      contacts: [],
      timezone: null,
      total: 0,
      contactInfo: {},
      loading: false,
      updating: false,
    };
  },

  created() {
    this.getContacts();

    EventBus.$on('get-contacts', () => {
      this.getContacts();
    });

    Echo.private("contacts")
      .listen("NewContact", (event) => {
        this.getContacts();
      });

    Echo.private("contacts")
      .listen("UpdateContacts", (event) => {
        this.getContacts();
      });
  },

  methods: {

    formatWebsite(website) {
      // remove www. if present
      website = website.replace(/^www\./, '');
      if (!website.startsWith('http://') && !website.startsWith('https://')) {
        return 'https://' + website;
      }
      return website;
    },

    showModalViewContact(contact) {
      this.contactInfo = contact;
      this.$refs.ViewContact.cancelDelete();
      this.$bvModal.show('bv-modal-view-contact-' + this.page);
    },

    showModalEditContact(contact) {
      this.contactInfo = contact;
      this.$bvModal.show('bv-modal-edit-contact-' + this.page);
    },

    getContacts() {

      this.loading = true;

      axios
        .post(`/contacts/get`, {
          search_term: this.search_term,
          status: this.status,
          category: this.category,
        })
        .then((response) => {
          this.contacts = response.data.contacts;
          this.total = response.data.total;
          this.timezone = response.data.timezone;
          this.loading = false;
        });
    },

    sendMessage(contact) {
      $(`.send_link_${contact.id}`).hide();
      $(`.sending_${contact.id}`).addClass('display_unset');

      axios
        .post(`/contacts/send-email`, { contact: contact })

        .then((response) => {

          EventBus.$emit('get-contacts');

          this.copyEmail(contact);
        
      }).catch((error) => {

        this.sweetfire(error.response.data.message);

      }).finally(() => {
        $(`.sending_${contact.id}`).removeClass('display_unset');
        $(`.send_link_${contact.id}`).show();
      });

    },

    copyEmail(contact) {
      let email = contact.emails[0];
      navigator.clipboard.writeText(email).then(function() {
        console.log('Email copied: ' + email);
      }, function(err) {
        console.error('Could not copy email: : ', err);
      });
    },

    unsubscribe(contact) {

      $(`.unsub_link_${contact.id}`).hide();
      $(`.unsub_${contact.id}`).addClass('display_unset');

      axios
        .post(`/contacts/unsubscribe`, { contact: contact })
        .then((response) => {
          if (response.data.success) {
            EventBus.$emit('get-contacts');
          } else {
            alert(response.data.message);
          }
          $(`.unsub_${contact.id}`).removeClass('display_unset');
          $(`.unsub_link_${contact.id}`).show();
          
        });
    },

    contacted(contact) {

      this.updating = true;
      // $(`.unsub_link_${contact.id}`).hide();
      $(`.unsub_${contact.id}`).addClass('display_unset');

      axios
        .post(`/contacts/contacted`, { contact: contact })
        .then((response) => {
          if (response.data.success) {
            EventBus.$emit('get-contacts');
          } else {
            alert(response.data.message);
          }
          $(`.unsub_${contact.id}`).removeClass('display_unset');
          // $(`.unsub_link_${contact.id}`).show();
          this.updating = false;
        });
    },

  },
};
</script> 